import React from 'react';
import ContentLoader from 'react-content-loader';

import { Stack } from '@lyearn/ui';

const Loader = () => (
  <Stack className="px-16 pt-20 pb-24" justifyContent="between">
    <ContentLoader
      backgroundColor="var(--s-info-light)"
      foregroundColor="var(--interactive-secondary)"
      height={310}
      speed={2}
      viewBox="0 0 128 310"
      width={128}>
      <rect height="16" rx="4" ry="4" width="128" x="4" y="0" />
      <rect height="16" rx="4" ry="4" width="128" x="4" y="42" />
      <rect height="16" rx="4" ry="4" width="128" x="4" y="84" />
      <rect height="16" rx="4" ry="4" width="128" x="4" y="126" />
      <rect height="16" rx="4" ry="4" width="128" x="4" y="168" />
      <rect height="16" rx="4" ry="4" width="128" x="4" y="238" />
      <rect height="16" rx="4" ry="4" width="128" x="4" y="280" />
    </ContentLoader>
    <ContentLoader
      backgroundColor="var(--s-info-light)"
      foregroundColor="var(--interactive-secondary)"
      height={310}
      speed={2}
      viewBox="0 0 20 310"
      width={20}>
      <rect height="20" rx="4" ry="4" width="20" x="0" y="0" />
      <rect height="20" rx="4" ry="4" width="20" x="0" y="42" />
      <rect height="20" rx="4" ry="4" width="20" x="0" y="84" />
      <rect height="20" rx="4" ry="4" width="20" x="0" y="126" />
      <rect height="20" rx="4" ry="4" width="20" x="0" y="168" />
      <rect height="20" rx="4" ry="4" width="20" x="0" y="238" />
      <rect height="20" rx="4" ry="4" width="20" x="0" y="280" />
    </ContentLoader>
  </Stack>
);

export default Loader;
